import { useEffect, useState } from "react";
import GroupRequests from "../../../Services/Api/GroupRequets.ts";
import { useParams } from "react-router-dom";
import ServerTypes from "../../../Services/Data/ServerTypes.js";
import GroupButtons from "../../../Components/GroupButtons/GroupButtons.js";
import GroupServers from "./GroupOptions/Servers/GroupServers.js";
import GroupUsers from "./GroupOptions/Users/GroupUsers.js";
import UserInGameRoles from "./GroupOptions/InGameRoles/UserInGameRoles.js";
import { FaPen, FaTrash } from "react-icons/fa";
import AddEditGroupModal from "../Components/AddEditGroupModal/AddEditGroupModal.js";
import ModalWindow from "../../../Components/ModalWindow/ModalWindow.js";
import { useNavigate } from "react-router-dom";

const GroupInfo = ({refreshServers}) => {
    const navigate = useNavigate();
    const groupRequests = new GroupRequests();

    const { groupId } = useParams();
    
    const[group, setGroup] = useState(null);

    const [selected, setSelected] = useState(0);
    const [editGroup, setEditGroup] = useState(false);    
    const [deleteModal, setDeleteModal] = useState(false);

    useEffect(() => {
        refresh();
    }, [groupId])
    
    const refresh = () => {
        groupRequests.Get(groupId, (group) =>  {setGroup(group)});
    }

    const deleteGroup = () => {
        groupRequests.Delete(groupId, () => {
            setDeleteModal(false);
            refreshServers();
            navigate("/");
        });
    };
    
    if(!group)
        return (<></>);

    const type = ServerTypes.find(x => x.Id == group.serverType);

    if(!type) 
        return (<></>);

    return (
        <>
            <div class="card bg-glgray-600 rounded-2xl flex-col center-y w-full px-4 py-3">
                <div className="flex">
                    <div className="flex-1">
                        <h2>Grupa</h2>
                        <div class="cardContent">
                            <p>Nazwa: {group.name}</p>
                            <div className="flex">
                                <p>Typ: </p>
                                <img src={`../images/GameIcons/${group.serverType}.png`} className="size-6 ml-4 mr-2"/>
                                <p>{type.Name}</p>
                            </div>
                        </div>
                    </div>
                    <div className="mr-1">
                        <FaPen size={"22px"} className="mt-4 iconBtn" onClick={() => setEditGroup(true)}/>
                        <FaTrash size={"22px"} className="mt-4 iconBtn" onClick={() => setDeleteModal(true)}/>
                    </div>
                </div>
            </div>
            <div class="card bg-glgray-600 rounded-2xl flex-col center-y w-full px-4 py-3 mt-4">
                <GroupButtons 
                    buttons={[
                        { text: "Serwery" }, 
                        { text: "Użytkownicy" }, 
                        { text: "Role w grze" }
                    ]}
                    selected={selected}
                    setSelected={setSelected}
                />
                <div className="mt-5">
                    { selected == 0 &&
                        <GroupServers groupId={groupId} />
                    }
                    { selected == 1 &&
                        <GroupUsers groupId={groupId} />
                    }    
                    { selected == 2 &&
                        <UserInGameRoles groupId={groupId} />
                    }                       
                </div>            
            </div>
            { editGroup &&
                <AddEditGroupModal editData={group} hide={() => { setEditGroup(false); refresh() }}/>
            }
            { deleteModal &&
                <ModalWindow 
                    title={"Usuwanie grupy"}
                    buttons={[
                        { Text: "Usuń", onClick: () => deleteGroup(groupId) },
                        { Text: "Anuluj", className: "modalSecondaryBtn", onClick: () => setDeleteModal(false) }
                    ]}
                    content={
                        <div className="p-4">
                            <p>Czy na pewno chcesz usunąć grupę <span className="text-glred">'{group.name}'</span>?</p>
                            <p>Akcji nie można cofnąć!</p>
                        </div>
                    }
                />
            }
        </>
    )
}

export default GroupInfo;